import { useState } from 'react';

type GroupOperator = 'AND' | 'OR';

interface UseMultiSelectStateReturn {
    fieldLabels: Record<string, Record<string, string>>;
    multiSelectInValues: Record<string, any[]>;
    multiSelectOutValues: Record<string, any[]>;
    multiSelectOperator: Record<string, GroupOperator>;
    setFieldLabels: (
        updater:
            | Record<string, Record<string, string>>
            | ((prev: Record<string, Record<string, string>>) => Record<string, Record<string, string>>)
    ) => void;
    setMultiSelectInValues: (
        updater: Record<string, any[]> | ((prev: Record<string, any[]>) => Record<string, any[]>)
    ) => void;
    setMultiSelectOutValues: (
        updater: Record<string, any[]> | ((prev: Record<string, any[]>) => Record<string, any[]>)
    ) => void;
    setMultiSelectOperator: (
        updater:
            | Record<string, GroupOperator>
            | ((prev: Record<string, GroupOperator>) => Record<string, GroupOperator>)
    ) => void;
}

export const useMultiSelectState = (): UseMultiSelectStateReturn => {
    const [uiState, setUIState] = useState<{
        fieldLabels: Record<string, Record<string, string>>;
        multiSelectInValues: Record<string, any[]>;
        multiSelectOutValues: Record<string, any[]>;
        multiSelectOperator: Record<string, GroupOperator>;
    }>({
        fieldLabels: {},
        multiSelectInValues: {},
        multiSelectOutValues: {},
        multiSelectOperator: {},
    });

    const setFieldLabels = (
        updater:
            | Record<string, Record<string, string>>
            | ((prev: Record<string, Record<string, string>>) => Record<string, Record<string, string>>)
    ) => {
        setUIState(prev => ({
            ...prev,
            fieldLabels: typeof updater === 'function' ? updater(prev.fieldLabels) : updater,
        }));
    };

    const setMultiSelectInValues = (
        updater: Record<string, any[]> | ((prev: Record<string, any[]>) => Record<string, any[]>)
    ) => {
        setUIState(prev => ({
            ...prev,
            multiSelectInValues: typeof updater === 'function' ? updater(prev.multiSelectInValues) : updater,
        }));
    };

    const setMultiSelectOutValues = (
        updater: Record<string, any[]> | ((prev: Record<string, any[]>) => Record<string, any[]>)
    ) => {
        setUIState(prev => ({
            ...prev,
            multiSelectOutValues: typeof updater === 'function' ? updater(prev.multiSelectOutValues) : updater,
        }));
    };

    const setMultiSelectOperator = (
        updater:
            | Record<string, GroupOperator>
            | ((prev: Record<string, GroupOperator>) => Record<string, GroupOperator>)
    ) => {
        setUIState(prev => ({
            ...prev,
            multiSelectOperator: typeof updater === 'function' ? updater(prev.multiSelectOperator) : updater,
        }));
    };

    return {
        fieldLabels: uiState.fieldLabels,
        multiSelectInValues: uiState.multiSelectInValues,
        multiSelectOutValues: uiState.multiSelectOutValues,
        multiSelectOperator: uiState.multiSelectOperator,
        setFieldLabels,
        setMultiSelectInValues,
        setMultiSelectOutValues,
        setMultiSelectOperator,
    };
};
